const lenis = new Lenis({
	// lerp: 0.1, // Lower easing factor for smoother scrolling (default: 0.1)
	wheelMultiplier: 0.8, // Reduce mouse wheel sensitivity
	touchMultiplier: 1.5, // Increase touch device sensitivity
	infinite: false, // Disable infinite scroll to save resources
	smoothWheel: true, // Ensure smooth wheel scrolling is enabled
	smoothTouch: true, // Enable smooth touch scrolling
	duration: 1.2, // Scroll animation duration (seconds)
});

// expose lenis to window
window.lenis = lenis;

function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

lenis.on("scroll", ScrollTrigger.update);

gsap.ticker.add((time) => {
	lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);
